"use client"

import { TrendingUp } from "lucide-react"
import { Label, Legend, PolarRadiusAxis, RadialBar, RadialBarChart } from "recharts"
import * as React from "react"

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/Card"
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../../components/ui/chart"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
  } from "../../components/ui/Select"

import { Separator } from "../ui/Seprator"

// const chartData = [{ month: "january", occupancy: null, vacancy: null }]

// const chartConfig = {
//   occupancy: {
//     label: "תפוס",
//     color: "hsl(var(--chart-1))",
//   },
//   vacancy: {
//     label: "פנוי",
//     color: "hsl(var(--chart-2))",
//   },
// }

// const locationHebrewName = {
//   "AHAD_HA'AM": "אחד העם",
//   "SAN_MARTIN": "סן מרטין",
//   "ZVI": "שדרות צבי",
//   "BERNSTEIN": "פרץ ברנשטיין",
//   "CENTER_OF_THE_PARK": "חניוני לב הפארק"
// }

export function Component({ totalVisitors,chartData,chartConfig,locationHebrewName,deviceNames,setActiveMonth,activeMonth,vacancyValue,totalParkingSpace }) {
    // const [activeMonth, setActiveMonth] = React.useState(deviceNames[0]);
    // let totalParkingSpace = totalParkingSpaces[deviceNames.findIndex(deviceName=>deviceName===activeMonth)];
    // let vacancyValue = vacancyValues[deviceNames.findIndex(deviceName=>deviceName===activeMonth)];
    // console.log(vacancyValue, totalParkingSpace, deviceNames,"props");    
    // if (vacancyValue === "אלמ") {
    //     console.log(vacancyValue,"vacancyValue is null")
    //     vacancyValue = 0;
    //     console.log(vacancyValue,"vacancyValue is null")
    // }
    // chartData[0].occupancy = totalParkingSpace-vacancyValue;
    // chartData[0].vacancy = vacancyValue;
    // const totalVisitors = totalParkingSpace;


  return (
    <Card className="flex flex-col">
        <CardHeader className="flex items-center gap-2 space-y-0 border-b py-3 sm:flex-row">
         <div className="grid flex-1 gap-1 justify-end text-center sm:text-left">
            <Select value={activeMonth} onValueChange={setActiveMonth}>
            <SelectTrigger
                className="ml-auto h-7 w-[130px] rounded-lg pl-2.5"
                aria-label="Select a value"
            >
                <SelectValue placeholder="Select month" />
            </SelectTrigger>
            <SelectContent align="end" className="rounded-xl">
                {deviceNames.map((key) => {
                //   const config = chartConfig[key]

                //   if (!config) {
                //     return null
                //   }

                return (
                    <SelectItem
                    key={key}
                    value={key}
                    className="rounded-lg [&_span]:flex"
                    >
                    <div className="flex items-center gap-2 text-xs">
                        {/* <span
                        className="flex h-3 w-3 shrink-0 rounded-sm"
                        style={{
                            backgroundColor: `var(--color-${key})`,
                        }}
                        /> */}
                        {locationHebrewName[key]}
                    </div>
                    </SelectItem>
                )
                })}
            </SelectContent>
            </Select>
         </div>
        </CardHeader>
      <CardHeader className="flex-row justify-end space-y-0 pb-0">
        <div className="grid gap-1 text-right">
            <CardTitle>{locationHebrewName[activeMonth]}</CardTitle>
            <CardDescription>סך כל התפוסה אל מול המקומות הפנויים</CardDescription>
        </div>
        {/* <Select value={activeMonth} onValueChange={setActiveMonth}>
          <SelectTrigger
            className="ml-auto h-7 w-[130px] rounded-lg pl-2.5"
            aria-label="Select a value"
          >
            <SelectValue placeholder="Select month" />
          </SelectTrigger>
          <SelectContent align="end" className="rounded-xl">
            {deviceNames.map((key) => {
              const config = chartConfig[key]

              if (!config) {
                return null
              }

              return (
                <SelectItem
                  key={key}
                  value={key}
                  className="rounded-lg [&_span]:flex"
                >
                  <div className="flex items-center gap-2 text-xs">
                    <span
                      className="flex h-3 w-3 shrink-0 rounded-sm"
                      style={{
                        backgroundColor: `var(--color-${key})`,
                      }}
                    />
                    {key.replace("_", " ")}
                  </div>
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select> */}
      </CardHeader>
      <CardContent className="flex flex-1 items-center pb-0">
        <ChartContainer
          config={chartConfig}
          className="mx-auto aspect-square w-full max-w-[240px]"
        >
          <RadialBarChart
            data={chartData}
            endAngle={180}
            innerRadius={80}
            outerRadius={130}
          >
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <PolarRadiusAxis tick={false} tickLine={false} axisLine={false}>
              <Label
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle">
                        <tspan
                          x={viewBox.cx}
                          y={(viewBox.cy || 0) - 16}
                          className="fill-foreground text-2xl font-bold"
                        >
                          {totalVisitors.toLocaleString()}
                        </tspan>
                        <tspan
                          x={viewBox.cx}
                          y={(viewBox.cy || 0) + 4}
                          className="fill-muted-foreground"
                        >
                          סה״כ חניות
                        </tspan>
                      </text>
                    )
                  }
                }}
              />
            </PolarRadiusAxis>
            <RadialBar
              dataKey="occupancy"
              stackId="a"
              cornerRadius={5}
              fill="var(--color-occupancy)"
              className="stroke-transparent stroke-2"
            />
            <RadialBar
              dataKey="vacancy"
              fill="var(--color-vacancy)"
              stackId="a"
              cornerRadius={5}
              className="stroke-transparent stroke-2"
            />
            <Legend
              verticalAlign="bottom"
              align="center"
              iconSize={7}
              // style={{borderRadius:"30px"}}
              payload={[
                {
                  value: chartConfig.occupancy.label,
                  type: "square",
                  color: chartConfig.occupancy.color,
                  id: "occupancy"
                },
                {
                  value: chartConfig.vacancy.label,
                  type: "square",
                  color: chartConfig.vacancy.color,
                  id: "vacancy"
                }
              ]}
              formatter={(value) => (
                <span style={{ color: "black" }}>{value}</span> // Force text to be black
              )}
            />
          </RadialBarChart>
        </ChartContainer>
      </CardContent>
      <CardFooter className="flex-col gap-2 text-sm">
        <div className="flex items-center gap-2 font-medium leading-none">
          אחוז תפוסה אל מול מקומות פנויים בחניון  {/* <TrendingUp className="h-4 w-4" /> */}
        </div>
        <div className="flex h-5 items-center space-x-4 text-xs">
            <div className="leading-none text-muted-foreground" >תפוס {(totalParkingSpace-vacancyValue)<0? 0:(totalParkingSpace-vacancyValue)} ({Math[((totalParkingSpace-vacancyValue) / totalParkingSpace * 100 + Number.EPSILON) % 1 >= 0.5 ? 'ceil' : 'floor']((totalParkingSpace-vacancyValue) / totalParkingSpace * 100)<0?0:Math[((totalParkingSpace-vacancyValue) / totalParkingSpace * 100 + Number.EPSILON) % 1 >= 0.5 ? 'ceil' : 'floor']((totalParkingSpace-vacancyValue) / totalParkingSpace * 100)}%)</div>
            <Separator orientation="vertical" />
            <div className="leading-none text-muted-foreground" >פנוי {vacancyValue<0?0:vacancyValue} ({Math[(vacancyValue / totalParkingSpace * 100 + Number.EPSILON) % 1 >= 0.5 ? 'ceil' : 'floor'](vacancyValue / totalParkingSpace * 100)<0?0:Math[(vacancyValue / totalParkingSpace * 100 + Number.EPSILON) % 1 >= 0.5 ? 'ceil' : 'floor'](vacancyValue / totalParkingSpace * 100)}%)</div>
        </div>
      </CardFooter>
    </Card>
  )
}

export { Component as ShadRadialChart };
